var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-toolbar',{attrs:{"dense":"","color":"transparent","flat":""}},[_vm._v(" 펌웨어 관리 "),_c('v-spacer'),_c('FirmwareAdd')],1),_c('v-divider'),_c('FirmwareList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }